"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildNewMinorVersions = void 0;
exports.deleteIcon = deleteIcon;
exports.isVersionGroupPublic = isVersionGroupPublic;
exports.mergeIncompleteVersion = mergeIncompleteVersion;
exports.mergeVersion = mergeVersion;
exports.reorderMinorVersionsBySemver = reorderMinorVersionsBySemver;
exports.updateCategories = updateCategories;
exports.updateIcon = updateIcon;
exports.updateMinor = updateMinor;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _semver = _interopRequireDefault(require("semver"));
var _assets = require("../../../utils/assets");
var _utils = require("../utils");
var _arrays = require("../../../utils/arrays");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function mergeVersion(state, assetVersion) {
  var assetPath = (0, _assets.getGAKey)(assetVersion);
  var assetProperties = (0, _utils.extractAssetAgnosticProperties)(assetVersion);
  var currentAssetVersions = (state.data[assetPath] || {}).versions || {};
  var newAssetVersion = _objectSpread(_objectSpread({}, currentAssetVersions[assetVersion.version]), assetVersion);
  var newAssetVersions = _objectSpread(_objectSpread({}, currentAssetVersions), {}, (0, _defineProperty2.default)({}, assetVersion.version, _objectSpread(_objectSpread({}, newAssetVersion), {}, {
    files: newAssetVersion.files || [],
    labels: newAssetVersion.labels || [],
    organization: newAssetVersion.organization || newAssetVersion.organizationId && {
      id: newAssetVersion.organizationId
    }
  })));
  var lastVersion = Object.keys(newAssetVersions).filter(function (version) {
    return !newAssetVersions[version].isDeleted;
  }).sort(function (v1, v2) {
    return _semver.default.rcompare(v1, v2);
  })[0];
  var assetMetadata = _objectSpread(_objectSpread(_objectSpread({}, state.data[assetPath]), assetProperties), {}, {
    lastVersion: lastVersion,
    versions: newAssetVersions
  });
  var newState = _objectSpread(_objectSpread({}, state), {}, {
    data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, assetPath, assetMetadata))
  });
  return newState;
}
function mergeIncompleteVersion(state, assetVersion) {
  var assetPath = (0, _assets.getGAKey)(assetVersion);
  var assetVersions = (state.data[assetPath] || {}).versions || {};
  if (assetVersions[assetVersion.version] && assetVersions[assetVersion.version].isCompleted && !assetVersions[assetVersion.version].isMinorVersionTransition) {
    return state;
  }
  return mergeVersion(state, assetVersion);
}
function updateMinor(state, assetVersion, newProperties) {
  var _state$data$assetPath;
  var assetPath = (0, _assets.getGAKey)(assetVersion);
  var versions = Object.values(((_state$data$assetPath = state.data[assetPath]) === null || _state$data$assetPath === void 0 ? void 0 : _state$data$assetPath.versions) || []).reduce(function (accum, $assetVersion) {
    if ($assetVersion.minorVersion === assetVersion.minorVersion) {
      return _objectSpread(_objectSpread({}, accum), {}, (0, _defineProperty2.default)({}, $assetVersion.version, _objectSpread(_objectSpread({}, $assetVersion), newProperties)));
    }
    return _objectSpread(_objectSpread({}, accum), {}, (0, _defineProperty2.default)({}, $assetVersion.version, $assetVersion));
  }, {});
  return _objectSpread(_objectSpread({}, state), {}, {
    data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, assetPath, _objectSpread(_objectSpread({}, state.data[assetPath]), {}, {
      versions: versions
    })))
  });
}
function isVersionGroupPublic(objectsWithVersionGroup, currentVersionGroup) {
  var matchVersionGroup = objectsWithVersionGroup.find(function (mv) {
    return mv === currentVersionGroup;
  });
  return !!matchVersionGroup;
}
function reorderMinorVersionsBySemver(minorVersions) {
  return minorVersions.sort(function (mv1, mv2) {
    return _semver.default.rcompare("".concat(mv1.minorVersion, ".0"), "".concat(mv2.minorVersion, ".0"));
  });
}
function updateCategories(state, updateFn) {
  return Object.keys(state.data).reduce(function (gaAccum, ga) {
    var versions = Object.keys(state.data[ga].versions).reduce(function (versionsAccum, version) {
      return _objectSpread(_objectSpread({}, versionsAccum), {}, (0, _defineProperty2.default)({}, version, _objectSpread(_objectSpread({}, state.data[ga].versions[version]), {}, {
        categories: updateFn(state.data[ga].versions[version].categories, state.data[ga].type)
      })));
    }, {});
    var newAsset = _objectSpread(_objectSpread({}, state.data[ga]), {}, {
      versions: versions
    });
    return _objectSpread(_objectSpread({}, gaAccum), {}, (0, _defineProperty2.default)({}, ga, newAsset));
  }, {});
}
function updateIcon(assetParent, icon) {
  var versions = assetParent.versions;
  if (!versions) {
    return _objectSpread(_objectSpread({}, assetParent), {}, {
      icon: icon
    });
  }
  var versionsWithoutIcon = Object.keys(versions).reduce(function (result, version) {
    var _assetVersion$files;
    var assetVersion = versions[version];
    return _objectSpread(_objectSpread({}, result), {}, (0, _defineProperty2.default)({}, version, _objectSpread(_objectSpread({}, assetVersion), {}, {
      files: (_assetVersion$files = assetVersion.files) === null || _assetVersion$files === void 0 ? void 0 : _assetVersion$files.filter(function (file) {
        return file.classifier !== 'icon';
      })
    })));
  }, {});
  return _objectSpread(_objectSpread({}, assetParent), {}, {
    icon: icon,
    versions: versionsWithoutIcon
  });
}
function deleteIcon(assetParent) {
  return updateIcon(assetParent, null);
}
var getStatusesByMinorVersion = function getStatusesByMinorVersion(assets, $minorVersion) {
  var newStatuses = assets.reduce(function (statuses, _ref) {
    var minorVersion = _ref.minorVersion,
      status = _ref.status;
    return minorVersion === $minorVersion ? [].concat((0, _toConsumableArray2.default)(statuses), [status]) : statuses;
  }, []);
  return (0, _arrays.uniq)(newStatuses);
};
var buildNewMinorVersions = exports.buildNewMinorVersions = function buildNewMinorVersions(_ref2) {
  var state = _ref2.state,
    asset = _ref2.asset,
    _ref2$assets = _ref2.assets,
    assets = _ref2$assets === void 0 ? [] : _ref2$assets;
  var assetPath = (0, _assets.getGAKey)(asset);
  var groupId = asset.groupId,
    assetId = asset.assetId,
    versionGroup = asset.versionGroup,
    minorVersion = asset.minorVersion,
    status = asset.status;
  var currentMinorVersions = state.minorVersions[assetPath] || [];
  var currentVersionGroups = state.versionGroups[assetPath] || [];
  var doesMinorVersionExist = currentMinorVersions.some(function (mv) {
    return mv.minorVersion === minorVersion;
  });
  var newMinorVersion = {
    groupId: groupId,
    assetId: assetId,
    versionGroup: versionGroup,
    minorVersion: minorVersion,
    statuses: [status],
    isPublic: isVersionGroupPublic(currentVersionGroups.filter(function (currentVersionGroup) {
      return currentVersionGroup.isPublic;
    }).map(function (currentVersionGroup) {
      return currentVersionGroup.versionGroup;
    }), versionGroup)
  };
  var newMinorVersions = doesMinorVersionExist ? currentMinorVersions.map(function (currentMinorVersion) {
    return currentMinorVersion.minorVersion === minorVersion ? _objectSpread(_objectSpread({}, currentMinorVersion), {}, {
      statuses: !assets.length ? (0, _arrays.uniq)([].concat((0, _toConsumableArray2.default)(currentMinorVersion.statuses), [status])) : getStatusesByMinorVersion(assets, minorVersion)
    }) : currentMinorVersion;
  }) : reorderMinorVersionsBySemver([].concat((0, _toConsumableArray2.default)(currentMinorVersions), [newMinorVersion]));
  return newMinorVersions;
};
//# sourceMappingURL=utils.js.map